module.exports = __webpack_public_path__ + "img/humberger.372c0cee.svg";